import processMapViewConfigs from 'hb-react/frontoffice/utils/processMapViewConfigs';

export const mapViewSettings = ({
  configs: mapViewConfigs,
  currentUser,
  location,
}) => {
  if (!currentUser && !mapViewConfigs) {
    // We always display the toggle, but we're hiding the Google Map (and so the toggle) from China only.
    return {
      isMapInitiallyDisplayed: false,
      userCanToggleMap: !window.is_from_china,
      initialCenter: [0, 0],
      initialZoom: 1,
    };
  }

  return processMapViewConfigs({
    ...mapViewConfigs,
    currentUser,
    location,
  });
};
